import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';

import ErrorBlock from 'components/ErrorBlock';
import Label from 'components/Label';
import {TextField, SearchCountryField} from 'components/Fields';
import FormField from 'components/FormField';
import {selectModal} from 'ducks/modals';
import {selectCountries} from 'ducks/countries';
import {MODALS, createAddressHistory} from 'ducks/bookings';
import {required} from 'utils/validators';

import './styles.css';

const onSubmit = (values, dispatch, props) => {
  const {agreementUserId} = props;
  const extraActions = props.getExtraActions();

  const data = {
    agreementUserId,
    street: _.get(values, 'street', ''),
    city: _.get(values, 'city', ''),
    country: _.get(values, 'country.code', ''),
    state: _.get(values, 'state', ''),
    postalCode: _.get(values, 'postcode', ''),
    location: props.locationRef
  };

  dispatch(createAddressHistory(data, extraActions));
};

class AddressHistoryForm extends React.Component<any> {
  render() {
    const {error, countries} = this.props;

    return (
      <form className="AddressHistoryForm">
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <FormField>
          <Label>country</Label>
          <SearchCountryField countries={countries} required />
        </FormField>
        <FormField>
          <Label>city</Label>
          <Field
            name="city"
            className="kyc_city"
            component={TextField}
            validate={[required]}
          />
        </FormField>
        <FormField>
          <Label>state</Label>
          <Field name="state" className="kyc_state" component={TextField} />
        </FormField>
        <FormField>
          <Label>street address</Label>
          <Field
            name="street"
            className="kyc_street_address"
            component={TextField}
            validate={[required]}
          />
        </FormField>
        <FormField>
          <Label>postcode</Label>
          <Field
            name="postcode"
            className="kyc_postcode"
            component={TextField}
            validate={[required]}
          />
        </FormField>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const countries = selectCountries(state);
  const {data: {agreementUserId}} = selectModal(state, MODALS.ADDRESS_HISTORY);

  return {agreementUserId, countries};
};

const addressHistoryForm = reduxForm({
  form: 'addressHistory',
  onSubmit: onSubmit
})(AddressHistoryForm);

export default connect(mapStateToProps)(addressHistoryForm);
